import { render, staticRenderFns } from "./ColoredLayout.vue?vue&type=template&id=525893d3&scoped=true&"
import script from "./ColoredLayout.vue?vue&type=script&lang=js&"
export * from "./ColoredLayout.vue?vue&type=script&lang=js&"
import style0 from "./ColoredLayout.vue?vue&type=style&index=0&id=525893d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525893d3",
  null
  
)

export default component.exports